'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
require('../style-222d2b0f.js');
var s16 = require('../typography/s16.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  gap: 10px;\n"], ["\n  display: flex;\n  gap: 10px;\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  position: relative;\n  white-space: nowrap;\n"], ["\n  position: relative;\n  white-space: nowrap;\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  font-family: \"Source Sans Pro\", sans-serif;\n"], ["\n  font-family: \"Source Sans Pro\", sans-serif;\n"]);

var Container = styled__default.div(_templateObject);

var TrailContainer = styled__default.div(_templateObject2);

var TrailText = styled__default(s16.default)(_templateObject3);

var InputGroupWithTrail = function InputGroupWithTrail(_ref) {
  var children = _ref.children,
      trailText = _ref.trailText,
      mt = _ref.mt,
      rest = _babelHelpers.objectWithoutProperties(_ref, ["children", "trailText", "mt"]);
  return React__default.createElement(
    Container,
    null,
    children,
    React__default.createElement(
      TrailContainer,
      null,
      React__default.createElement(
        TrailText,
        _babelHelpers._extends({}, rest, { mt: mt }),
        trailText
      )
    )
  );
};

InputGroupWithTrail.propTypes = {
  /** Trail text */
  trailText: PropTypes$1.string,
  /** Margin top for trail text */
  mt: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
};

InputGroupWithTrail.defaultProps = {
  trailText: "default",
  mt: "42"
};
InputGroupWithTrail.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InputGroupWithTrail",
  "props": {
    "trailText": {
      "defaultValue": {
        "value": "\"default\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Trail text"
    },
    "mt": {
      "defaultValue": {
        "value": "\"42\"",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Margin top for trail text"
    }
  }
};

exports.Container = Container;
exports.TrailContainer = TrailContainer;
exports.TrailText = TrailText;
exports.default = InputGroupWithTrail;
//# sourceMappingURL=with-trail.js.map
